import React, { useEffect } from "react";
import {
  ContainerReports,
  ContainerIframe,
  YammerUrl,
} from "./YammerContainer.styled";

const YammerContainer = () => {
  const iframe =
    '<iframe name="main-feed" title="Yammer" src="https://web.yammer.com/embed/feed" style="border: 0px; overflow: hidden; width: 100%; height: 100%; min-height: 610px;"></iframe>';

  // const iframe =
  //   '<iframe name="embed-feed" title="Yammer" style="border: 0px; overflow: hidden; width: 100%; height: 100%; min-height: 610px;"></iframe>'

  useEffect(() => {
    // setTimeout(function(){
    //   scriptjs('https://c64.assets-yammer.com/assets/platform_embed.js', function(){
    //   //$('#embed-feed').remove();
    //   window.yam.connect.embedFeed({
    //          container: '#embedded-feed',
    //          network: 'fourleaf.com',
    //          feedType: 'group',                // can be 'group', 'topic', or 'user'
    //          feedId: '78957993984'
    //      });
    //   });
    //   }, 1000);
    //   yam.connect.embedFeed({
    //     container: '#embedded-feed',
    //     network: 'fourleaf.com',
    //     feedType: 'group',                // can be 'group', 'topic', or 'user'
    //     feedId: '78957993984'
    // });
  }, []);

  return (
    <ContainerReports>
      <YammerUrl>
        Note: In case of entire access to Yammer, please visit this&nbsp;
        <a
          href="https://web.yammer.com/main/feed"
          target="_blank"
          rel="noopener noreferrer"
        >
          URL
        </a>
        .
      </YammerUrl>
      <ContainerIframe
        contentEditable="true"
        dangerouslySetInnerHTML={{ __html: iframe }}
      ></ContainerIframe>
    </ContainerReports>
  );
};

export default YammerContainer;
